import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button, { BUTTON_WIDTH, BUTTON_TYPE } from '@gc-npm/components.button';
import { COLORS} from '@gc-npm/utils.enums.colors';
import ShoppingCart900 from '@/components/ShoppingCart/ShoppingCart900'

import RecomendererSection from '@/components/Recomendador/SmartRecomender/recomenderSection';
import { actions as uiActions } from '@/reducers/ui';
import { getComponentProductForTagging } from '@/utils/recomendador';
import { API_STATUS, SCREEN_TYPES } from '@/utils/constants';

export const SmartRecomender = ({ info, screenType, className}) => {
  const dispatch = useDispatch();

  const selectedItems = useSelector((state) => state.recomendator?.selectedItems);
  const status = useSelector((state) => state.recomendator.status?.init);
  const context = useSelector((state) => state.main.context);

  const cssLoading = status === API_STATUS.LOADING && 'skeleton';
  const fiber = info?.filters?.fiberSpeeds;
  const mobileLines = info?.filters?.mobileLines;
  const tvChannels = info?.filters?.tvChannels;
  const infoFiber = {
    filters: fiber,
    title: info?.textos?.filtersTexts?.fiberSpeedsTitle || '¿Qué velocidad de Fibra quieres?',
    subTitle: info?.textos?.filtersTexts?.fiberSpeedsSubtitle || 'Incluye dispositivo desde 0€ y TV básica',
  }
  const infoMobileLines = {
    filters: mobileLines,
    title: info?.textos?.filtersTexts?.mobileLinesTitle || '¿Cuántas líneas móviles necesitas?',
    subTitle: info?.textos?.filtersTexts?.mobileLinesSubtitle || 'Podrás añadir más líneas cuando necesites',
  }
  const infoTvchannels = {
    filters: tvChannels,
    title: info?.textos?.filtersTexts?.tvChannelsTitle || '¿Qué Televisión te interesa?',
    additionalActionsTitle: info?.textos?.filtersTexts?.tvChannelsSubtitle || 'No quiero televisión',
    switchOffButton: true,
  }

  const tagginInfoContinuar = {
    componentContent: 'continuar',
    componentName: 'button-configurar-recomendador',
    componentProduct: '',
    componentVariation: 'All',
  }

  const rawInfoFiberSelected = infoFiber?.filters?.find((item) => item.id === selectedItems?.fiber);
  let tvNotAllowed = false;
  if (
    rawInfoFiberSelected?.incompatibles?.tvChannels?.length > 0
    && rawInfoFiberSelected?.incompatibles?.tvChannels.includes('all')
  ) {
    tvNotAllowed = true;
  }

  const onClickContinuar = () => {
    if ((selectedItems.fiber && selectedItems.mobileLines)) {
      let getProperties = [];
      if (selectedItems?.fiber) {
        getProperties.push(`fiber=${selectedItems.fiber}`);
      }
      if (selectedItems?.mobileLines) {
        getProperties.push(`mobileLines=${selectedItems?.mobileLines}`)
      }
      if (selectedItems?.tvChannels) {
        getProperties.push(`tvChannels=${selectedItems.tvChannels.join(';')}`)
      }
      getProperties = getProperties.join('&');
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('selection', JSON.stringify(selectedItems));
      }
      // dispatch(recomendatorActions.setHidratateMod('server' ))
      const env = context.environment?.name;
      let prefix = '';
      if (env === 'dev_ssr') {
        prefix = '/develop'
      } else if (env === 'qa_ssr') {
        prefix = '/qa'
      }
      const url2go = `${prefix}/fibra-y-movil/productos-recomendados/?data-abt=ver-detalle&${getProperties}`;
      window.location.href = url2go;
    } else {
      dispatch(uiActions.setNotification('Responde a todas las preguntas para ver opciones'));
    }
  }

  const classContainer = className ? "container": "";
  const URL = className ? 'https://prod.adb.col.movistar.es/content/dam/movistar//estaticos/fondos/fd-desl-01.jpg' : "";
  
  return (
    <div className="SmartRecomender" >
      <div className={classContainer}>

        <div className="SmartRecomender_wrapper ">
          <div className="SmartRecomender_sections">
            {fiber && (
            <RecomendererSection info={infoFiber} cssLoading={cssLoading} type="fiber" itemSelected={selectedItems?.fiber} />
            )}
            {mobileLines && (
            <RecomendererSection info={infoMobileLines} cssLoading={cssLoading} type="mobileLines" itemSelected={selectedItems?.mobileLines} />
            )}
            {tvChannels && (
            <RecomendererSection info={infoTvchannels} cssLoading={cssLoading} type="tvChannels" itemSelected={selectedItems?.tvChannels} tvNotAllowed={tvNotAllowed} />
            )}
            <div className={`SmartRecomender_footer ${cssLoading}`}>
              <div className="SmartRecomender_actions">
                <Button
                  label="Continuar"
                  onClick={onClickContinuar}
                  taggingInfo={{
                    ...tagginInfoContinuar,
                    componentProduct: getComponentProductForTagging(selectedItems),
                  }}
                  width={screenType === SCREEN_TYPES.MOBILE ? BUTTON_WIDTH.FULL : BUTTON_WIDTH.MEDIUM}
                  type={BUTTON_TYPE.PRIMARY}
                />
            <ShoppingCart900 phone="900 104 854" campaign="900104854-C2C" origin="productosRecomendados"/>

              </div>
            
          </div>
          </div>
          
        </div>
      </div>
      <style jsx>
        {`
          .SmartRecomender {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            background-image: url(${URL}) ;
            background-size: cover;
            background-position: center;
            width: 100%;
            padding: 1rem 0;
          }

          .SmartRecomender_wrapper {
            border-radius: 0.5rem;
            border: 1px solid ${COLORS.grey300};
            width: 100%;
            background-color: white;
            padding: 1.5rem;
            padding-bottom: 1rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between; 
            align-items: center;           
            gap: 1rem;
          }
          .SmartRecomender_sections {
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            row-gap: 1.5rem;
            width: 100%;
            justify-content: space-between;

          }
          .SmartRecomender_footer {
            width: 100%;
            display: flex;
            justify-content: center;
          }
          .SmartRecomender_actions {
            display: flex;
            flex-direction: row;
            gap: 1rem;
            max-width: 550px;
            align-content: center;
            align-items: center;
          }


          /* Media queries */
          @media (max-width: 767px) {
            .SmartRecomender {
              padding: 0.5rem 0;
            }
            .SmartRecomender_wrapper {
              padding: 0.75rem 0.4rem;
            }
            .SmartRecomender_sections {
              gap: 0.6rem;
              margin: 0 auto;    
              width: 380px;
              justify-content:center;
            }
            .SmartRecomender_actions {
              display: flex;
              flex-direction: column;
              gap: 1rem;
              align-content: center;
              align-items: center;
            }
          }
          @media (max-width: 430px) {
            .SmartRecomender_wrapper {
              padding: 0.75rem 0.3rem;
            }
            .SmartRecomender_sections {
              width: 356px;    
              margin: 0 auto;
            }
          }
          @media (max-width: 390px) {
            .SmartRecomender_wrapper {
              padding: 0.75rem 0.3rem;
            }
            .SmartRecomender_sections {
              max-width: 324px;
              margin: 0 auto;
            }
          }
        `}
      </style>
    </div>
  )
}

export default SmartRecomender;
